import React from 'react';
import {
  Paper,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Chip,
  Box
} from '@mui/material';
import {
  School as TrainingIcon,
  Timer as DurationIcon,
  Assignment as GuideIcon
} from '@mui/icons-material';

interface Guide {
  id: string;
  title: string;
  description: string;
  duration: string;
  category: 'basic' | 'advanced' | 'required';
  completed?: boolean;
}

const mockGuides: Guide[] = [
  {
    id: '1',
    title: 'Getting Started with PSA System',
    description: 'Basic overview of the system and its core features',
    duration: '30 mins',
    category: 'required',
    completed: true
  },
  {
    id: '2',
    title: 'Attendance Management Basics',
    description: 'Learn how to track and manage student attendance',
    duration: '45 mins',
    category: 'basic'
  },
  {
    id: '3',
    title: 'Advanced Intervention Strategies',
    description: 'Deep dive into creating effective intervention plans',
    duration: '60 mins',
    category: 'advanced'
  }
];

export const OnboardingGuides: React.FC = () => {
  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'required':
        return 'error';
      case 'advanced':
        return 'warning';
      case 'basic':
        return 'info';
      default:
        return 'default';
    }
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <TrainingIcon sx={{ mr: 1 }} />
        <Typography variant="h6">
          Onboarding & Training Guides
        </Typography>
      </Box>

      <List>
        {mockGuides.map((guide) => (
          <ListItem
            key={guide.id}
            disablePadding
            sx={{ mb: 2, bgcolor: 'background.paper', borderRadius: 1 }}
          >
            <ListItemButton>
              <ListItemIcon>
                <GuideIcon />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {guide.title}
                    <Chip
                      label={guide.category}
                      color={getCategoryColor(guide.category)}
                      size="small"
                    />
                    {guide.completed && (
                      <Chip
                        label="Completed"
                        color="success"
                        size="small"
                        variant="outlined"
                      />
                    )}
                  </Box>
                }
                secondary={
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body2" color="text.secondary">
                      {guide.description}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                      <DurationIcon fontSize="small" sx={{ mr: 0.5 }} />
                      <Typography variant="caption" color="text.secondary">
                        {guide.duration}
                      </Typography>
                    </Box>
                  </Box>
                }
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};